var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "replacement-part-finder__wrapper" }, [
    _c("div", { staticClass: "replacement-part-finder__container" }, [
      _c("div", { staticClass: "replacement-part-finder__bg-box" }, [
        _c("div", { staticClass: "replacement-part-finder" }, [
          _c(
            "div",
            { staticClass: "replacement-part-finder__head-container" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "replacement-part-finder__head replacement-part-finder__head--left",
                },
                [
                  _c("h1", [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "OD3dprimaV2::Template.replacementPartFinderHeadline"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.replacementPartFinderText"
                          )
                        ) +
                        "\n                        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "replacement-part-finder__head replacement-part-finder__head--right",
                },
                [
                  _c("lazy-img", {
                    attrs: {
                      "image-url": _vm.imageTablet,
                      "image-url-tablet": _vm.imageTablet,
                      "image-url-desktop": _vm.imageDesktop,
                      alt: _vm.$translate(
                        "OD3dprimaV2::Template.replacementPartFinderHeadline"
                      ),
                      title: _vm.$translate(
                        "OD3dprimaV2::Template.replacementPartFinderHeadline"
                      ),
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "replacement-part-finder__select-container" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "replacement-part-finder__select replacement-part-finder__select--left",
                },
                [
                  _c(
                    "div",
                    { staticClass: "replacement-part-finder__select-wrapper" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.replacementPartFinderSelectBrand"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.selectBrand($event.target.value)
                            },
                          },
                        },
                        [
                          !_vm.facets.values.length
                            ? _c("option", { attrs: { value: "0" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.replacementPartFinderSelectBrandPlaceholder"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.manufacturers, function (item) {
                            return item.details.length > 0
                              ? _c("option", { domProps: { value: item.id } }, [
                                  _vm._v(_vm._s(item.details[0].name)),
                                ])
                              : _vm._e()
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "replacement-part-finder__select replacement-part-finder__select--right",
                  class: {
                    "replacement-part-finder__select--inactive":
                      !_vm.facets.values.length,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "replacement-part-finder__select-wrapper" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.replacementPartFinderSelectModel"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          ref: "modelselect",
                          on: {
                            change: function ($event) {
                              return _vm.selectModel($event.target.value)
                            },
                          },
                        },
                        [
                          !_vm.itemList.length
                            ? _c("option", { attrs: { value: "0" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "OD3dprimaV2::Template.replacementPartFinderSelectModelPlaceholder"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.facets.values, function (item) {
                            return _c(
                              "option",
                              { domProps: { value: item.id } },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.itemList.length
        ? _c("div", { staticClass: "replacement-part-finder__itemlist" }, [
            _c(
              "div",
              { staticClass: "replacement-part-finder__filter" },
              [
                _c(
                  "a",
                  {
                    class: { active: _vm.activeFacet === 0 },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.selectFacet(0)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "OD3dprimaV2::Template.replacementPartFinderShowAll"
                        )
                      )
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.facetsForFilter.values, function (facet) {
                  return _c(
                    "a",
                    {
                      class: {
                        active:
                          _vm.activeFacet === _vm.facetPropMapping[facet.id],
                      },
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.selectFacet(_vm.facetPropMapping[facet.id])
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(facet.name) +
                          "\n                "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "product-list row",
                attrs: { id: "js--product-list" },
              },
              [
                _vm._l(_vm.itemList, function (item) {
                  return _vm.isInFacetSelection(_vm.facetPropertyId(item.id))
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "product-list__col col-12 col-md-4 col-xl-2-4",
                        },
                        [
                          _c(
                            "category-item",
                            { key: item.id, attrs: { "item-data": item.data } },
                            _vm._l(item.layoutContainer, function (container) {
                              return _c("div", {
                                attrs: { slot: container.id },
                                domProps: {
                                  innerHTML: _vm._s(container.content),
                                },
                                slot: container.id,
                              })
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "product-list__col product-list__col--no-items col-12",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$translate(
                          "OD3dprimaV2::Template.replacementPartFinderNoItems"
                        )
                      )
                    ),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _vm.currentPage < _vm.maxPages
              ? _c("div", { staticClass: "mt-4 mb-4 text-center" }, [
                  _c(
                    "button",
                    { staticClass: "btn btn-primary trigger-load-more" },
                    [
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$translate(
                                "OD3dprimaV2::Template.loadMoreLoading"
                              )
                            ) +
                            "\n                    "
                        ),
                      ],
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: " is-loading" }),
    _vm._v(" "),
    _vm.loadingFromSelects
      ? _c(
          "div",
          {
            staticClass:
              "replacement-part-finder__loading-overlay d-none d-lg-block is-loading",
          },
          [
            _c("i", {
              staticClass: "fa fa-circle-o-notch fa-spin mobile-icon-right",
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }